import { createContext } from 'react';

const MapDataFetchCallbackContext = createContext<() => void>(() => {});

export default MapDataFetchCallbackContext;

export const useMapDataFetchCallbackContext = () => {
  return useContext(MapDataFetchCallbackContext);
};
